exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-name {\n  margin-top: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/crear-ficha/crear-ficha.component.css
// module id = ../../../../../src/app/pages/admin/crear-ficha/crear-ficha.component.css
// module chunks = main